export default __webpack_public_path__ + "static/media/image16.3cf1a5e4.jpg";